// Sticky Tables Functionality
document.addEventListener('DOMContentLoaded', function() {
  // Auto-aplicar sticky headers y ajuste responsive
  function applyStickyHeaders() {
    const autoElements = document.querySelectorAll('.auto-sticky-tables');
    autoElements.forEach(element => {
      const tables = element.querySelectorAll('table.table');
      tables.forEach(table => {
        // Ignorar tablas con clase no-sticky-override
        if (table.classList.contains('no-sticky-override')) {
          return;
        }
        
        const tbody = table.querySelector('tbody');
        const rows = tbody ? tbody.querySelectorAll('tr') : [];
        
        if (rows.length > 10 && !table.closest('.table-sticky-header')) {
          const wrapper = document.createElement('div');
          wrapper.className = 'table-sticky-header';
          wrapper.style.maxHeight = '70vh';
          wrapper.style.overflowY = 'auto';
          // overflow-x se maneja via CSS (overflow-x: auto en móviles) para no romper el scroll lateral
          
          table.parentNode.insertBefore(wrapper, table);
          wrapper.appendChild(table);
          
          // Agregar efecto de scroll
          wrapper.addEventListener('scroll', function() {
            if (this.scrollTop > 0) {
              this.classList.add('scrolling');
            } else {
              this.classList.remove('scrolling');
            }
          });
        }
      });
    });
    
    // Función para ajustar tablas automáticamente
    function adjustTableColumns() {
      const tableContainers = document.querySelectorAll('.table-container, .table-sticky-header');
      
      tableContainers.forEach(container => {
        const table = container.querySelector('table');
        if (!table) return;
        
        const headers = table.querySelectorAll('thead th');
        const containerWidth = container.offsetWidth;
        const columnCount = headers.length;
        
        // Aplicar clases según número de columnas
        if (columnCount > 8) {
          table.classList.add('table-many-columns');
        } else if (columnCount > 5) {
          table.classList.add('table-medium-columns');
        }
        
        // Ajustar ancho de columnas dinámicamente
        if (containerWidth < 768) {
          table.classList.add('table-mobile');
        } else {
          table.classList.remove('table-mobile');
        }
      });
    }
    
    adjustTableColumns();
    
    // Reagrupar en cambio de tamaño de ventana
    let resizeTimeout;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(adjustTableColumns, 250);
    });
  }
  
  // Aplicar sticky headers a tablas existentes
  applyStickyHeaders();
  
  // Observar cambios en el DOM para nuevas tablas
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'childList') {
        const addedNodes = Array.from(mutation.addedNodes);
        if (addedNodes.some(node => node.nodeType === 1 && (node.matches('table') || node.querySelector('table')))) {
          applyStickyHeaders();
        }
      }
    });
  });
  
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});
